export enum paymentMethod {
  card = "card",
  ussd = "ussd",
  transfer = "transfer",
  qrCode = "qrCode",
  wallet = "wallet",
  bank = "bank",
}
